import { useLayoutEffect, useState } from 'react'
import { Trans } from '@lingui/react/macro'

/** Leaves the WebView for the app. The link shows only if that navigation stays here. */
export function AndroidProductsRedirect({ url }: { url: string }) {
  const [showLink, setShowLink] = useState(false)

  useLayoutEffect(() => {
    window.location.replace(url)
    const showFallback = window.setTimeout(() => setShowLink(true), 1000)
    return () => window.clearTimeout(showFallback)
  }, [url])

  if (!showLink) {
    return null
  }

  return (
    <main className="flex h-full w-full items-center justify-center p-8">
      <a className="btn btn-primary" href={url}>
        <Trans>Continue</Trans>
      </a>
    </main>
  )
}
